/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{goodsInfo.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="evaluationContent">
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="ownerInfo" v-for="commentListItem in commentList" :key="commentListItem.bXyDoeid">
            <div class="ownerInfo_left">
              <el-image class="avartarImg" :src="commentListItem.profile_photo">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="ownerInfo_right">
              <span style="margin-right: 10px">{{
                encryption(commentListItem.createBy||'匿名', 4)
              }}</span>
              <span>{{ commentListItem.createTime }}</span>
              <p style="font-size: 18px; color: #757575">
                {{ commentListItem.content }}
              </p>
              <el-image v-if='commentListItem.images!=null&&commentListItem.images!=""' class="commentListImg" :src="commentListItem.images" :preview-src-list="[commentListItem.images]">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
          <el-divider></el-divider>
        </el-col>
        <el-col :span="8">
          <!-- <goodsCard :bigImgSize='1' :isAddCart='1' :isOpenCart='1' :item='goodsList' :getcollectionList='getCommoditylistDetail'></goodsCard> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import "@/assets/css/goodsDetail/goodsDetail.css";
import { commoditylist,area_list,findEvaluation } from "@/api/xunyou";
import {mapState,mapMutations} from 'vuex'
import goodsCard from '@/components/goodsCard'
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      successInfo: true,
      addDialogVisible: false,
      openGoodsVisible: false,
      urlImg: "",
      formLabelAlign: {
        values: null,
        textarea: "",
      },
      ruleForm: {
        localImg: "",
        netAddress: "",
      },
      commentList: [{
        id: 1,
        name: "xunyou测试员",
        time: "2020-10-20 00:12:23",
        content: "非常好，非常好",
        photos: require("@/assets/images/commend1.jpg"),
        avatar: require("@/assets/images/commend1.jpg"),
      }],

      goodsInfo: 
        {
          id: 1,
          name: "鱼尾旗袍新款改良复古修身蕾丝中式旗袍 黄色 蕾丝",
          realprice: 368,
          evaluator: 3,
          photos: require("@/assets/images/commend1.jpg"),
        }
      ,
      rules: {
        localImg: [
          {
            required: true,
            message: "不能为空,请上传图片",
            trigger: ["blur", "change"],
          },
        ],
        values: [{ required: true, message: "请评分", trigger: "blur" }],
        textarea: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
      },
      
      goodsSize: "",
      num1: 1, //商品数量
      // getprovince: [], // 地址联动
      cascaderAreaValue: [], // 发货地址
      shippingAreaValue: [], // 收货地址

    };
  },
  // 注册组件
  components: {goodsCard},
  computed:{
    ...mapState(['getprovince'])
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getprovinceList();
    //this.getCommoditylistDetail()
    this.getfindEvaluation()
    // this.getcollectionList();
  },
  mounted() {
    
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    /*----------------- 查询右侧商品信息 开始--------------------*/
  getCommoditylistDetail() {
      this.loading = true;
      commoditylist({id: this.$route.query.goodId,stype:'',userId:this.userInfo.userId})
        .then((res) => {
            if (res.code == 0) {
                this.loading = false;
                this.goodsList = res.rows[0];
                // this.moreImgArr = res.rows[0].more_photos.split(',');
                // this.bigphotos = this.moreImgArr[0]
                // this.searchStorerList(this.info.mid)
            }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
        });
    },
     /*----------------- 查询右侧商品信息 结束--------------------*/

   

    //  名字加密
    encryption(str, len) {
      if (str.length <= len) {
        return str;
      } else {
        var newStr = str.substring(0, 1);
        var newStrs = str.substring(str.length - 1, str.length - 2);
        newStr = newStr + "***" + newStrs;
        return newStr;
      }
    },
  
    //   上传图片
    uploadImg() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // alert('上传图片')
          this.addDialogVisible = false;
          //   comment(this.formLabelAlign)
          //       .then((res) => {
          //           if (res.code == 0) {
          //               this.$message({
          //                   type: 'success',
          //                   message: '评论成功!'
          //               });
          //           }else{
          //             this.$message.error(res.msg);
          //           }
          //       })
          //       .catch((err) => {
          //         this.loading = false;
          //         this.$message.error("评论失败，请稍后再试！");
          //       });
        } else {
          return false;
        }
      });
    },

    // 查询商品评价详情
    getfindEvaluation(){
      findEvaluation({
        uid:this.userInfo.userId,
        bXyDoeid:this.$route.query.evaluationId,
        goodId:this.$route.query.goodId,
        oid:this.$route.query.oid,
        type:2,//2 商品  1 店铺
      })
      .then((res) => {
          if (res.code == 0) {
            if(res.rows.length>0){
              this.commentList = res.rows;
            }
            if(null!=this.commentList)
            {
              this.goodsInfo.name=this.commentList[0].goodsName
            }
          }else{
            this.$message.error(res.msg);
          }
      })
      .catch((err) => {
        this.loading = false;
        this.$message.error("查询商品评价详情失败，请稍后再试！");
      });

    },

    //   支付凭证上传
    handleAvatarSuccess(res, file) {
      console.log(res, file.raw, URL.createObjectURL(file.raw));
      this.urlImg = URL.createObjectURL(file.raw); // 用来图片预览的
      this.sizeForm.localImg = URL.createObjectURL(file.raw);
      this.payForImg = res.url;
      // this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style scoped lang="less">
.evaluationContent {
  padding: 60px;
  font-size: 14px;
  background: white;
  .ownerInfo {
    display: flex;
    justify-content: space-between;
    .ownerInfo_left {
      flex: 1;
      .avartarImg {
        width: 60px;
        height: 60px;
        background: #f1f1f1;
        border-radius: 10px;
      }
    }
    .ownerInfo_right {
      flex: 8;
      .commentListImg {
        width: 30%;
        height: auto;
        border: 1px solid #ccc;
        padding: 10px;
        margin-top: 20px;
      }
    }
  }
  .wholeInfoBox {
    // width: 80%;
    height: auto;
    margin-bottom: 50px;
    position: relative;
    .addCartOpreate {
      display: none;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 75px;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      text-align: center;
      line-height: 40px;
      transition: all 0.45s ease;
    }
    .attentiontOpreate {
      display: none;
      position: absolute;
      right: 0;
      top: 0;
      .el-button--warning {
        color: #fff;
        background-color: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        border-color: transparent;
        display: block;
        margin-left: 0 !important;
        margin-bottom: 10px;
      }
    }
    .el-el-image {
      width: 100%;
      height: auto;
    }
    .goodsText {
      text-align: center;
      margin-bottom: 4px;
    }
    .mark {
      display: none;
      font-size: 14px;
      background: rgba(255, 255, 255, 0.8);
      position: relative;
      .redeemNow {
        background: #78b942;
        padding: 6px;
        text-align: center;
        color: white;
        cursor: pointer;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        border-radius: 6px;
      }
      .redeemNow:hover {
        background-color: rgba(34, 34, 34, 0.85);
      }
    }
  }
  .wholeInfoBox:hover {
    .addCartOpreate {
      display: block;
      cursor: pointer;
    }
    .addCartOpreate:hover {
      background: #78b942;
    }
    .attentiontOpreate {
      display: block;
      cursor: pointer;
    }
    .el-button--warning:hover {
      background: #78b942;
    }
  }
  .textareaBox {
    margin: 20px 0;
  }
  .rateBox {
  }
  .opreatContent {
    .howToWrite {
      font-size: 12px;
      color: #757575;
      margin: 6px 0px;
    }
    .buttonGrop {
      text-align: right;
    }
  }
  button.el-button.buttonBgd.el-button--primary {
    background-color: #78b942;
    border-color: #78b942;
  }
}
.addCartInfoBox {
  .cascaderArea.el-cascader {
    /deep/input[disabled],
    /deep/input[disabled="disabled"],
    /deep/input[readonly],
    /deep/input[readonly="readonly"] {
      background-color: white;
    }
  }
}
// .addCartBox{
//     /deep/.avatar-uploader {
//               padding-bottom: 15px;
//               box-sizing: border-box;
//           }
//       /deep/.el-upload.el-upload--text {
//               border: 1px solid #ccc;
//           }

//       .avatar-uploader .el-upload {
//           border: 1px dashed #d9d9d9;
//           border-radius: 6px;
//           cursor: pointer;
//           position: relative;
//           overflow: hidden;
//       }
//       .avatar-uploader .el-upload:hover {
//           border-color: #409EFF;
//       }
//       .avatar-uploader-icon {
//           font-size: 28px;
//           color: #8c939d;
//           width: 178px;
//           height: 178px;
//           line-height: 178px;
//           text-align: center;
//       }
//       .avatar {
//           width: 160px;
//           height: 160px;
//           display: block;
//       }
//       button.el-button.buttonBgd.el-button--primary {
//        background-color: #78b942;
//        border-color: #78b942;
//     //    font-size: 18px;
//     //    margin: 20px 0;
//    }

// }
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/evaluationePage/evaluationDetail.vue